// extracted by mini-css-extract-plugin
module.exports = {"fifthFold":"fifthFold_fifthFold__oXvIX","heading":"fifthFold_heading__6PXa6","subParagraph":"fifthFold_subParagraph__xZfiU"};